import { render } from "./ModalNicknameInfo.vue?vue&type=template&id=7f2c2d8c&scoped=true&ts=true"
import script from "./ModalNicknameInfo.vue?vue&type=script&lang=ts"
export * from "./ModalNicknameInfo.vue?vue&type=script&lang=ts"

import "./ModalNicknameInfo.vue?vue&type=style&index=0&id=7f2c2d8c&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2c2d8c"]])

export default __exports__